import * as React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { CircularProgress } from 'material-ui';
import DatePicker from 'react-date-picker';

export interface IMarkAsCompletedPopOverProps {
    onUpdate: (comments, date) => void;
}

export interface IMarkAsCompletedPopOverState {
    isLoading: boolean;
    date: any;
    comments: string;
}

export class MarkAsCompletedPopOver extends
    React.PureComponent<IMarkAsCompletedPopOverProps, IMarkAsCompletedPopOverState> {
    constructor(props: IMarkAsCompletedPopOverProps) {
        super(props);
        this.state = { isLoading: false, date: new Date(), comments: '' };
    }

    get comments() {
        return this.state.comments;
    }

    get date() {
        return this.state.date;
    }
    public handleMarkAsComplete = () => {

        const comments = this.state.comments;
        const date = this.state.date;
        this.props.onUpdate(comments, date);
    }
    renderPopOver = () => {
        const popoverBottom = (
            <Popover id="popover-positioned-bottom" title="Comments:">
                {this.state.isLoading ? <div style={loaderStyle} >
                    <CircularProgress size={70} color="#A4BF43" thickness={5} />
                </div> : ''}
                <span style={{ color: '#b7b7b7', fontWeight: 'bold' }}  >Select Date:</span>
                <DatePicker
                    value={this.state.date}
                    onChange={date => this.setState({ date })}
                    locale="en-US"
                />
                <textarea
                    rows={3}
                    placeholder="Add your comments..."
                    onChange={e => this.setState({ comments: e.target.value })}
                />
                {
                    this.state.comments.length > 0 ?
                        <div className="popover-submit" >
                            <button onClick={this.handleMarkAsComplete} className="submit-comments" >
                                Done
                            </button>
                        </div>
                        : ''
                }
            </Popover >
        );
        return <OverlayTrigger key="overlay" rootClose trigger="click" placement="bottom" overlay={popoverBottom} >
            {this.props.children}
        </OverlayTrigger>;

    }

    render() {
        return this.renderPopOver();
    }
}
const loaderStyle: React.CSSProperties = {
    position: 'absolute',
    height: '85%',
    width: '100%',
    left: 0,
    bottom: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5490196078431373)',
    zIndex: 1,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/MarkAsCompletePopOver.tsx